// Календарь на странице соревнований: листание месяцев + фильтрация списка под ним.
// Текущий месяц — «все старты» (список как есть), любой другой — только он.
function initCompetitionsCalendar() {
    var wrap = document.getElementById('competitions-calendar');
    if (!wrap) return;

    var titleEl = document.getElementById('competitions-calendar-title');
    var hintEl = document.getElementById('competitions-calendar-hint');
    var hintMonthEl = document.getElementById('competitions-calendar-hint-month');
    var months = Array.prototype.slice.call(wrap.querySelectorAll('.competitions-calendar-month'));
    if (!months.length) return;

    var groups = Array.prototype.slice.call(document.querySelectorAll('.competitions-group'));
    var emptyEl = document.getElementById('competitions-empty-month');
    var currentKey = wrap.dataset.currentMonth;
    var index = Math.max(0, months.findIndex(function (m) { return m.dataset.month === currentKey; }));

    var prevBtn = wrap.querySelector('[data-direction="prev"]');
    var nextBtn = wrap.querySelector('[data-direction="next"]');

    function applyFilter(key, label) {
        // Текущий месяц показывает весь список — так задумано владельцем.
        var showAll = key === currentKey;
        var shown = 0;
        groups.forEach(function (g) {
            var visible = showAll || g.dataset.month === key;
            g.hidden = !visible;
            if (visible) shown += 1;
        });
        if (emptyEl) emptyEl.hidden = shown !== 0;
        if (hintEl) {
            hintEl.hidden = showAll;
            if (hintMonthEl) hintMonthEl.textContent = label || '';
        }
    }

    function showMonth(newIndex) {
        index = Math.min(months.length - 1, Math.max(0, newIndex));
        months.forEach(function (m, i) {
            m.style.display = i === index ? 'block' : 'none';
        });
        var active = months[index];
        var label = active.dataset.monthLabel || '';
        if (titleEl) titleEl.textContent = label;
        if (prevBtn) prevBtn.classList.toggle('events-calendar-nav--disabled', index <= 0);
        if (nextBtn) nextBtn.classList.toggle('events-calendar-nav--disabled', index >= months.length - 1);
        applyFilter(active.dataset.month, label);
    }

    wrap.addEventListener('click', function (e) {
        var navBtn = e.target.closest('[data-direction]');
        if (navBtn && !navBtn.classList.contains('events-calendar-nav--disabled')) {
            e.preventDefault();
            showMonth(navBtn.dataset.direction === 'prev' ? index - 1 : index + 1);
            return;
        }
        if (e.target.closest('.competitions-calendar-reset')) {
            e.preventDefault();
            var currentIndex = months.findIndex(function (m) { return m.dataset.month === currentKey; });
            showMonth(currentIndex >= 0 ? currentIndex : 0);
        }
    });

    showMonth(index);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompetitionsCalendar);
} else {
    initCompetitionsCalendar();
}
